import { createElement } from "react";
import type { RouteObject } from "react-router";
import { PasswordPage } from "./PasswordPage";
import { DevicesPage } from "./DevicesPage";
import { EmailPage } from "./EmailPage";
import { PhonePage } from "./PhonePage";
import { ProfilePage } from "./ProfileCard";

/**
 * ACCOUNTS.md §3 — 账号与安全. `/account/password` must stay reachable while
 * `must_change_password` is set, so it is mounted outside `RequirePasswordChange`.
 */
export const passwordRoute: RouteObject = {
  path: "/account/password",
  element: createElement(PasswordPage),
};

export const routes: RouteObject[] = [
  { path: "/account/devices", element: createElement(DevicesPage) },
  // ACCOUNTS.md §4 — optional verified email for 忘记密码自助
  { path: "/account/profile", element: createElement(ProfilePage) },
  { path: "/account/email", element: createElement(EmailPage) },
  { path: "/account/phone", element: createElement(PhonePage) },
];

export { PasswordPage, DevicesPage, EmailPage, PhonePage };
